import React from 'react'
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

import 'filepond/dist/filepond.min.css'
import _ from 'lodash'

registerPlugin( FilePondPluginFileValidateType )

const TechBaseFilePond = props => {
  let{
    files,
    acceptedFileTypes,
    allowMultiple,
    actionKey,
    onUpdate=() => {}
  } = props.item

  const hasFilesProps = !_.isUndefined( props[ files ] )

  return(
    <FilePond
      { ...hasFilesProps ? { files: props[ files ] } : {} }
      acceptedFileTypes={ acceptedFileTypes }
      onupdatefiles={ props.onClickAction ? fileItems => props.onClickAction( actionKey, fileItems ) : fileItems => onUpdate(fileItems)}
      allowMultiple={ allowMultiple }
    />
  )
}

export default TechBaseFilePond
